import { useFormContext } from "react-hook-form";

import {
  selectBasicQuestions,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { FormTextField } from "@covertree/ui";

import { HomeDetailsForm } from "../validatorsAndTypes/homeDetailsAndConstructionForm";
import { InformationBox } from "@covertree/ui/content";
import { Typography } from "@mui/material";
import { theme } from "@covertree/theme";

interface Props {
  name?: string;
  label?: React.ReactNode;
  tooltip?: string;
  disabled?: boolean;
  fontSize?: number;
  labelFontSize?: number;
}

export function MakeCustomInput({
  name = "makeCustom",
  label = "Custom Make",
  tooltip = "Enter the manufacturer (make) if it is not in the dropdown list.",
  disabled = false,
  fontSize,
  labelFontSize,
}: Props) {
  const { makeCustom } = useNewBusinessSelector(selectBasicQuestions);

  const { control, setValue } = useFormContext<HomeDetailsForm>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(
      name as keyof HomeDetailsForm,
      e.target.value === "" ? null : e.target.value,
      { shouldValidate: true }
    );
  };

  return (
    <InformationBox
      sx={{
        m: 0,
        px: 4,
        pt: { xs: 4, md: 0 },
        pb: 4,
      }}>
      <FormTextField
        id="makeCustom"
        dataTestId="make-custom-input"
        name={name}
        label={makeCustom?.label ?? label}
        tooltip={makeCustom?.tooltip ?? tooltip}
        control={control}
        optional
        disabled={disabled}
        onChange={handleChange}
        fontSize={fontSize}
        labelFontSize={labelFontSize}
        sx={{
          backgroundColor: theme.palette.common.white,
        }}
      />
      <Typography variant="body2" mt={2} fontSize={16}>
        Please provide the exact manufacturer name
      </Typography>
    </InformationBox>
  );
}
